const cards = [
  {
    title: '香蕉视频',
    desc: '热门电影电视剧聚合，每日更新最新资源，高清画质流畅播放，影迷追剧首选平台。',
    tag: '影视聚合',
    icon: 'ri-movie-2-line',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20strip%20with%20warm%20golden%20lighting%2C%20abstract%20movie%20scene%20collage%2C%20soft%20coral%20and%20amber%20gradient%20background%2C%20elegant%20cinema%20aesthetic%2C%20dramatic%20lighting%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-banana-video&orientation=landscape',
    color: 'primary',
  },
  {
    title: '红桃视频',
    desc: '独家高清资源库，涵盖院线大片与热门剧集，画质清晰色彩饱满，观影体验出众。',
    tag: '独家资源',
    icon: 'ri-film-line',
    img: 'https://readdy.ai/api/search-image?query=Warm%20rose%20toned%20abstract%20cinematic%20composition%20with%20soft%20bokeh%20lights%2C%20elegant%20film%20aesthetic%2C%20flowing%20gradient%20curves%2C%20luxurious%20theater%20atmosphere%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-redpeach-video&orientation=landscape',
    color: 'accent',
  },
  {
    title: '91视频',
    desc: '经典内容宝库，收录海量影史佳作与怀旧经典，随时重温那些难忘的银幕瞬间。',
    tag: '经典宝库',
    icon: 'ri-treasure-map-line',
    img: 'https://readdy.ai/api/search-image?query=Classic%20film%20archive%20aesthetic%20with%20vintage%20warm%20tones%2C%20old%20hollywood%20glamour%20abstract%20background%2C%20golden%20light%20leaks%2C%20retro%20cinema%20atmosphere%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-91-video&orientation=landscape',
    color: 'secondary',
  },
  {
    title: '蜜桃视频',
    desc: '最新剧集持续更新，追剧党必备平台，同步各大平台热播内容，精彩不错过。',
    tag: '剧集更新',
    icon: 'ri-tv-2-line',
    img: 'https://readdy.ai/api/search-image?query=Modern%20streaming%20entertainment%20concept%20with%20soft%20peach%20and%20coral%20gradients%2C%20abstract%20digital%20screens%2C%20warm%20ambient%20glow%2C%20contemporary%20media%20aesthetic%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-peach-video&orientation=landscape',
    color: 'primary',
  },
  {
    title: '高清影院',
    desc: '蓝光画质专区，精选高品质片源，画面细腻色彩真实，带来影院级观影享受。',
    tag: '蓝光画质',
    icon: 'ri-4k-line',
    img: 'https://readdy.ai/api/search-image?query=Premium%20cinema%20quality%20abstract%20visual%20with%20deep%20blacks%20and%20warm%20highlights%2C%20professional%20film%20projector%20light%20beam%2C%20luxurious%20theater%20ambiance%2C%20high%20contrast%20elegant%20composition%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-hd-cinema&orientation=landscape',
    color: 'accent',
  },
  {
    title: '综艺频道',
    desc: '热门综艺节目一站式汇集，搞笑、竞技、真人秀随心看，周末放松最佳伴侣。',
    tag: '综艺汇集',
    icon: 'ri-emotion-laugh-line',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20entertainment%20show%20abstract%20background%20with%20colorful%20warm%20stage%20lights%2C%20dynamic%20energy%20waves%2C%20festive%20atmosphere%2C%20cheerful%20golden%20and%20coral%20tones%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-variety-show&orientation=landscape',
    color: 'secondary',
  },
  {
    title: '动漫专区',
    desc: '热门番剧持续更新，日漫国漫一网打尽，二次元爱好者的追番必备聚集地。',
    tag: '番剧连载',
    icon: 'ri-ghost-line',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20abstract%20composition%20with%20warm%20sunset%20gradients%20and%20soft%20magical%20particles%2C%20dreamy%20atmosphere%2C%20elegant%20illustration%20aesthetic%2C%20smooth%20color%20transitions%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-anime-zone&orientation=landscape',
    color: 'primary',
  },
];

const colorMap: Record<string, { bg: string; text: string; border: string }> = {
  primary: { bg: 'bg-primary-50', text: 'text-primary-700', border: 'border-primary-200' },
  accent: { bg: 'bg-accent-50', text: 'text-accent-700', border: 'border-accent-200' },
  secondary: { bg: 'bg-secondary-50', text: 'text-secondary-700', border: 'border-secondary-200' },
};

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            热门视频平台聚合
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            99视频一站式聚合香蕉视频、红桃视频、91视频、蜜桃视频等主流平台，海量影视资源任您挑选
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cards.map((card, idx) => {
            const c = colorMap[card.color];
            return (
              <article
                key={idx}
                className="group bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-[3/2] overflow-hidden bg-background-100">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading={idx < 4 ? undefined : 'lazy'}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
                  <span className={`absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium ${c.bg} ${c.text} ${c.border} border`}>
                    {card.tag}
                  </span>
                  <div className="absolute top-3 right-3 w-8 h-8 rounded-full bg-black/40 backdrop-blur-sm flex items-center justify-center">
                    <i className="ri-play-fill text-white text-sm"></i>
                  </div>
                </div>
                <div className="p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <div className={`w-7 h-7 rounded-lg ${c.bg} flex items-center justify-center`}>
                      <i className={`${card.icon} ${c.text} text-sm`}></i>
                    </div>
                    <h3 className="font-semibold text-foreground-950 text-sm">{card.title}</h3>
                  </div>
                  <p className="text-foreground-500 text-xs leading-relaxed">{card.desc}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}